module.exports = __webpack_public_path__ + "static/media/npmIcon.787bab7a.svg";